import { initReactI18next } from 'react-i18next'

import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import intervalPlural from 'i18next-intervalplural-postprocessor'

import { loadLanguageResources } from 'helpers/loadLanguageResources'

i18n
  .use({
    type: 'backend',
    read: async (lng, ns, callback) => {
      try {
        const resource = await loadLanguageResources(lng)
        callback(null, resource[ns])
      } catch (err) {
        callback(err, null)
      }
    },
  })
  .use(LanguageDetector)
  .use(intervalPlural)
  .use(initReactI18next)
  .init({
    detection: {
      order: ['querystring', 'navigator'],
      lookupQuerystring: 'lang',
    },
    load: 'languageOnly',
    defaultNS: 'common',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  })
  .catch((err) => console.error('i18n initialization failed:', err))
